import type { PILOT_LAST_CONNECTION_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-last-connection-card/pilot-last-connection-card.fr.ts";

export const PILOT_LAST_CONNECTION_CARD_ENGLISH_LOCALE = {
  title: "Last connection",
  ipAddress: "IP Address",
  status: "Status",
} satisfies typeof PILOT_LAST_CONNECTION_CARD_FRENCH_LOCALE;
